import React, { useContext } from 'react';
import theme from 'assets/theme';
import Topbar from '../Topbar';
import UserMenu from './UserMenu';
import { authContext } from 'helpers/services';


interface IProps {
    children: React.ReactNode
}

let ErrorLayout = ({ children }: IProps) => {
    let { isLoading } = useContext(authContext);

    return (
        <>
            <Topbar>
                {isLoading === false &&
                    <>
                        <div style={{ flexGrow: 1 }} />
                        <div style={{ display: 'flex' }}>
                            <UserMenu />
                        </div>
                    </>
                }
            </Topbar>
            <div style={{ padding: theme.spacing(2) }}>
                {children}
            </div>
        </>
    )
}

export default ErrorLayout;